/*
* Globals.js
*
* File for keeping globals ( constants at least ) to have a better overview
*
* TODO: SBE: Needless to say, I'm not a fan.
*/

/*****************************
* CONSTANTS
*****************************/

// names for local storage use
var G_LS_NAMES = {
	'DECK_CONTAINER_DATA': 'WELS_container_data',
	'DECK_DATA' : 'WELS_deck_data',
	'MASTER_DATA' : 'WELS_master_data',
	'MAIN_VESSEL_DATA' : 'WELS_vessel_data',
	'BULK_TANKS': 'WELS_bulk_tanks',
	'FUEL_LOG' : 'WELS_fuel_reporting_log',
	'VOYAGE_LOG' : 'WELS_voyage_event_log',
	'FUEL_DATA' : 'WELS_rob_data',
	'VOYAGE_VALIDATIONS': 'WELS_voyage_validations'
};


var G_CONSUMABLE_SEQ = {
    FUEL : 1,
    LNG : 2,
    POTWATER : 3,
    DRILLWATER : 4
}

// Page names
var G_PAGE = {
  'MAIN_PAGE'   : -1,
  'HOME_PAGE'   : 0,
  'DECK_PAGE'   : 1,
  'BULK_PAGE'   : 2,
  'VOYAGE_PAGE' : 3,
  'FUEL_PAGE'   : 4,
  'DEBUG_PAGE'  : 5
};

// Colour scheme for containers on deck
var G_CONTAINER_COLOURS = {
'TRANSIT': '#71BC78',
'DECK': '#AD8998',
'OUTGOING':	'#FF5349',
'CONSTRAINT': '#000000',
};

var G_CONTAINER_TYPES = {
	'REFRIGERATED': 'refrigerated'
};

// Deck scale
var G_DECK_SCALES = {
  'VESSEL': 25,
  'RIG': 15
};


var G_CONTAINING_DIV = '#deck';  // The main div for decks

var G_ROOT_ADDRESS = '/service/wels'; // Path to functions for interacting with DB


/*****************************
* Global variable variables :)
*****************************/

var g_voyage_planning = null; 	// Voyage planning state object
var g_fuel_planning = null;		// Fuel planning/reporting state object
var g_bulk_planning =  null;	// Bulk planning/reporting state object

var g_remote_object = null;     // Remote communication object
var g_master_data = null;		// Master data object
var g_localsave_object = null;	// The local storage save system



var g_current_page = G_PAGE['HOME_PAGE'];  // What page we are currently looking at

var g_ctrl_key_down = false;   // For avoiding double click conflicts when double clicking on a container
var g_dbl_container_pos = [];  // Last doubleclick on deck for adding new containers. Keeps track of x,y pos

var g_container_list = {}; // stores containers
var g_data_list = {};  // Stores data for user

var g_deck_list = {};  // Stores deck data
var g_deck_scale = G_DECK_SCALES['VESSEL']; // keeps track of deck scale
var g_current_deck;  // keeps track of current deck
var g_autosave_interval_id = null;  // interval id for autosaving deck
var g_container_is_dirty = false;  // whether any containers have been moved since previous autosave
var g_isDragging = false;
var g_selected_container = null;

var g_master_data2_fetched = false;

var g_timeStampFormat = "DD.MM.YYYY HH:mm"; //Default set to norwegian
var g_app_locale = "Europe/Oslo";

var g_actions = {
  load : 'load',
  offload : 'offload',
  backload : 'backload',
  discharge: 'discharge',
  dump: 'dump',
  start_rob : 'start_rob',
  rob : 'rob',
  tankCleanStarted : 'tank_clean_started',
  tankClean : 'tank_clean',
  deviation : 'deviation',
  transferTo : 'transfer_to',
  transferFrom : 'transfer_from',
  rob_adjustment : 'rob_adjustment'
};

var g_destination_type = {
  toRig : 'toRig',
  fromRig : 'fromRig',
  noRig : 'noRig'
};

var g_autoupdate_deck = false;

var g_dataIsReady = false;
